<template>
  <div class="marketing-consent-ui">
    <!-- <div class="marketing-consent-ui__section">
      <div class="marketing-consent-ui__disregard">
        <VCheckbox v-model="disregardAll" label="Disregard all marketing consent rules" />
      </div>
    </div> -->
    <ListingsFiltersSection
      title="Marketing Consent"
      description="Contacts can be filtered based on the marketing consent given by the customers"
      :is-disabled="disregardAll"
      :error-message="!filters.marketing_consent.length ? 'Please select at least one option' : undefined"
    >
      <VCheckbox
        v-model="filters.marketing_consent"
        :value="EMarketingConsent.GRANT"
        label="Yes"
        class="listings-filters"
        :disabled="disregardAll"
      />
      <VCheckbox
        v-model="filters.marketing_consent"
        :value="EMarketingConsent.DENY"
        label="Deny"
        class="listings-filters"
        :disabled="disregardAll"
      />
      <VCheckbox
        v-model="filters.marketing_consent"
        :value="EMarketingConsent.NOT_ASKED"
        label="Not set"
        class="listings-filters"
        :disabled="disregardAll"
      />
    </ListingsFiltersSection>
    <!-- <div class="marketing-consent-ui__section">
      <div class="marketing-consent-ui__heading">
        <VHeading
          :level="3"
          :class="[
            'marketing-consent',
            areContactPreferencesDisabled && 'marketing-consent-disabled',
          ]"
        >
          Contact preferences
        </VHeading>
        <VIconTooltip :icon-src="infoIcon">
          Filter based on specific contract preferences given to you by the customer
        </VIconTooltip>
      </div>
      <div class="marketing-consent-ui__cs-options">
        <div class="marketing-consent-ui__option">
          <VCheckbox
            v-model="filters.contact_preferences.email"
            label="Email"
            class="contact-preferences"
            :disabled="areContactPreferencesDisabled"
          />
        </div>
        <div class="marketing-consent-ui__option">
          <VCheckbox
            v-model="filters.contact_preferences.phone"
            label="Phone"
            class="contact-preferences"
            :disabled="areContactPreferencesDisabled"
          />
        </div>
        <div class="marketing-consent-ui__option">
          <VCheckbox
            v-model="filters.contact_preferences.sms"
            label="SMS"
            class="contact-preferences"
            :disabled="areContactPreferencesDisabled"
          />
        </div>
        <div class="marketing-consent-ui__option">
          <VCheckbox
            v-model="filters.contact_preferences.post"
            label="Post"
            class="contact-preferences"
            :disabled="areContactPreferencesDisabled"
          />
        </div>
        <div class="marketing-consent-ui__option">
          <VCheckbox
            v-model="filters.contact_preferences.other"
            label="Other"
            class="contact-preferences"
            :disabled="areContactPreferencesDisabled"
          />
        </div>
      </div>
    </div>
    <div class="marketing-consent-ui__heading">
      <VHeading
        :level="3"
        :class="['marketing-consent', isContactableSinceDisabled && 'marketing-consent-disabled']"
      >
        Contactable since initial contact within (days)
      </VHeading>
      <VIconTooltip :icon-src="infoIcon">
        Since the customer might not have given any indication on his marketing preferences, you can
        select to filter based on initial contact creation date (into Reapit) plus a specific number
        of days. Contacts that do not fit to this criteria will not be shown
      </VIconTooltip>
    </div>
    <div class="marketing-consent-ui__days-input">
      <VInput
        v-model="filters.contactable_since"
        class="marketing-consent"
        :config="{
          placeholder: 'Enter days',
          type: 'number',
          inputMode: 'numeric',
          min: 0,
          readonly: isContactableSinceDisabled,
        }"
      />
    </div> -->
  </div>
</template>

<script lang="ts" setup>
  // Types
  import type { TListingFilters } from '~/misc/listings/types';
  import { EMarketingConsent } from '~/misc/listings/types';

  // Components
  import ListingsFiltersSection from '~/misc/listings/filters/section/ListingsFiltersSection.vue';
  import VCheckbox from '~/misc/v-checkbox';
  // import VInput from '~/misc/v-input';

  const filters = defineModel({
    type: Object as PropType<TListingFilters>,
    required: true,
  });

  // TODO: implement when BE ready
  const disregardAll: Ref<boolean> = ref<boolean>(false);

  // const areContactPreferencesDisabled: ComputedRef<boolean> = computed<boolean>(
  //   () => filters.value.disregard_all || !filters.value.marketing_consent.yes
  // );

  // const isContactableSinceDisabled: ComputedRef<boolean> = computed<boolean>(
  //   () => filters.value.disregard_all || !filters.value.marketing_consent.notSet
  // );
</script>
